import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ViewUnionIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="viewUnion" ref={ref} {...props}>
      <path d="M22.75,10.26V18A3.76,3.76,0,0,1,19,21.7H9.21A3.76,3.76,0,0,1,5.46,18v-.46H5a3.76,3.76,0,0,1-3.75-3.75V6.05A3.76,3.76,0,0,1,5,2.3h9.79a3.76,3.76,0,0,1,3.75,3.75v.46H19A3.76,3.76,0,0,1,22.75,10.26Z" />
    </Icon>
  ),
) as IconWithRender;

ViewUnionIcon.displayName = 'ViewUnionIcon';
ViewUnionIcon.renderIcon = (props) => <ViewUnionIcon {...props} />;
export default ViewUnionIcon;
